import React, { Component } from "react";
import PropTypes from "prop-types";
import DropdownButton from 'react-bootstrap/DropdownButton';
import {
  Dropdown, Container, Button, Form, Modal 
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import FocusTrap from "focus-trap-react";
import CloseIcon from "../../assets/images/close-icon.svg";
import http from "../../api/http-request";
import {
  pageNotFound
} from "../../utils/common";

class ChangeEditNamePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: "",
      errorArray: [],
      formSubmitted: false,
      givenName:props.givenName,
      sn:props.sn,
      middleName:props.middleName === null ? '' : props.middleName,
      userId:props.userId,
      title: props.title ? props.title : props.t("pages.profile.pleaseSelect"),
      suffix: props.suffix ? props.suffix : props.t("pages.profile.pleaseSelect"),
      buttonName: ""
    };
  }
  
  componentDidMount = () => {
     if(this.props.isLogoutLinkPresent) {
        this.setState({
          buttonName: "pages.profile.saveAndLogout"
        });
      }
      else {
        this.setState({
          buttonName: "pages.profile.save"
        });
      }
  }

  getAPIHeaders = () => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    return {
      Authorization: `${bearer}${dataStoreToken}`,
    };
  };

  onNext = (e) => {
    e.preventDefault();
    const { givenName, sn } = this.state;
    const hasGivenName = this.isFormFieldValid(givenName, "givenNameError");
    const hasSn = this.isFormFieldValid(sn, "snError");
    if (
      hasGivenName ||
        hasSn 
    ) {
      this.showError("common.errors.required");
    } else {
      this.formSubmit(); 
    }
  }

  formSubmit = () => {
    const { onChangeEditNameHandler } = this.props;
    const {
      givenName,
      sn, userId, middleName, title, suffix 
    } = this.state;
    const usersId = userId;
    this.setState({
      errorText: ""
    });
    const payload = [
      {
        operation: "add",
        field: "/givenName",
        value: givenName.trim()
      },
      {
        operation: "add",
        field: "/sn",
        value: sn.trim()
      },
      {
        operation: "add",
        field: "/middleName",
        value: middleName === null ? '' : middleName.trim()
      },
      {
        operation: "add",
        field: "/title",
        value: title === this.props.t("pages.profile.pleaseSelect") ? '' : title
      },
      {
        operation: "add",
        field: "/suffix",
        value: suffix === this.props.t("pages.profile.pleaseSelect") ? '' : suffix
      }
    ];

    http(
      {
        url: `managed/user/${userId}`,
        method: "PATCH",
        data: payload
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      if (res && res.status === 200 && res.data && res.data._id === usersId) {
        onChangeEditNameHandler("success");
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else if (res.status === 400 && res.data.code === 400 && res.data.message === "BAD_REQUEST") {
        onChangeEditNameHandler("error");
      } else if (res.status === 401 && res.data.code === 401 && res.data.message === "ACCESS_DENIED") {
        onChangeEditNameHandler("error");
      }
    });
  }

  showError = (errorText) => {
    this.setState({
      errorText
    });
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  onFirstAndLastNameChange = (e, key) => {
    const {
      target: { value }
    } = e;
    if (value.match(/^[a-zA-Z '`,.-]*$/)) {
      this.setState({
        [key]: value
      });
    }
  };

  onMiddleNameChange = (e, key) => {
    const {
      target: { value }
    } = e;
    if (value.match(/^[a-zA-Z'`,.-]*$/)) {
      this.setState({
        [key]: value
      });
    }
  };

  isFormFieldValid = (e, key) => {
    const value = e.target ? e.target.value : e;

    let errorMsg = "";
    switch (key) {
      case "givenNameError":
        if (value.length <= 0 || (/^\s*$/.test(value))) {
          errorMsg = "common.errors.firstNameError";
        }
        break;
      case "snError":
        if (value.length <= 0 || (/^\s*$/.test(value))) {
          errorMsg = "common.errors.lastNameError";
        }
        break;
      default:
        errorMsg = "";
        break;
    }
    this.setState({
      [key]: errorMsg
    });
    return errorMsg;
  };

  render() {
    const { t, onClose, isLogoutLinkPresent } = this.props;
    const {
      givenName,
      sn,
      givenNameError,
      snError,
      middleName,
      middleNameError, title, suffix,
      buttonName
    } = this.state;

    return (
      <Modal
        show
        animation={false}
        onEscapeKeyDown={() => onClose()}
        aria-labelledby="mobile-modal"
      >
        <FocusTrap>
          <div className="popup change-edit-name">
            <Container fluid>
              <div className="popup__wrapper">
                <Form>
                  <div className="popup__wrapper-body">
                    <div className="popup__wrapper-body-header">
                      <h6 id="mobile-modal">
                        {t("pages.profile.editName")}
                      </h6>
                      <Button
                        className="popup__wrapper-body-header-close"
                        onClick={() => {
                          onClose();
                        }}
                        variant="light"
                        aria-label="Close"
                      >
                        <img src={CloseIcon} alt="" />
                      </Button>
                    </div>
                     
                    {
                      isLogoutLinkPresent && 
                      <div className="description-content">
                      <p>{t("pages.profile.profileUpdate")}</p>
                      </div>
                      } 
                    <Form.Label for="dropdown-menu-align-right">
                      {t("pages.editNamePopup.title")}
                    </Form.Label>
                    <DropdownButton
                      title={title}
                      id="dropdown-menu-align-right"
                      onSelect={(e) => {
                        this.setState({
                          title:e === '' ? t("pages.profile.pleaseSelect") : e
                        });
                      }}
                    >
                      <Dropdown.Item eventKey="">{t("pages.profile.pleaseSelect")}</Dropdown.Item>
                      <Dropdown.Item eventKey="Mr">Mr</Dropdown.Item>
                      <Dropdown.Item eventKey="Mrs">Mrs</Dropdown.Item>
                      <Dropdown.Item eventKey="Miss">Miss</Dropdown.Item>
                      <Dropdown.Item eventKey="Ms">Ms</Dropdown.Item>
                      <Dropdown.Item eventKey="Dr">Dr</Dropdown.Item>
                      <Dropdown.Item eventKey="Rev">Rev</Dropdown.Item>
                    </DropdownButton>

                    <Form.Group controlId="firstName">
                      <Form.Label>
                        {t("pages.profile.firstName")}
                        <span className="mandatory">*</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onFirstAndLastNameChange(
                            e,
                            "givenName"
                          );
                        }}
                        value={givenName}
                        maxLength="40"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "givenNameError");
                        }}
                        className={
                          givenNameError ? "error-input" : undefined
                        }
                        aria-required
                        aria-invalid={!!givenNameError}
                        aria-describedby="firstname-error"
                      />
                      <p className="error-text" id="firstname-error">
                        {givenNameError && t(givenNameError)}
                      </p>
                    </Form.Group>
                    <Form.Group controlId="middleName">
                      <Form.Label>
                        {t("pages.editNamePopup.middleName")}
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onMiddleNameChange(
                            e,
                            "middleName"
                          );
                        }}
                        value={middleName}
                        maxLength="40"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "middleNameError");
                        }}
                        className={
                          middleNameError ? "error-input" : undefined
                        }
                        aria-required
                        aria-invalid={!!middleNameError}
                        aria-describedby="firstname-error"
                      />
                      <p className="error-text" id="firstname-error">
                        {middleNameError && t(middleNameError)}
                      </p>
                    </Form.Group>

                    <Form.Group controlId="lastName">
                      <Form.Label>
                        {t("pages.profile.lastName")}
                        <span className="mandatory">*</span>
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          this.onFirstAndLastNameChange(e, "sn");
                        }}
                        value={sn}
                        maxLength="80"
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "snError");
                        }}
                        className={
                          snError ? "error-input" : undefined
                        }
                        aria-required
                        aria-invalid={!!snError}
                        aria-describedby="lastname-error"
                      />
                      <p className="error-text" id="lastname-error">
                        {snError && t(snError)}
                      </p>
                    </Form.Group>
                    <Form.Label for="dropdown-menu-suffix-align-right">
                      {t("pages.editNamePopup.suffix")}
                    </Form.Label>
                    <DropdownButton
                      title={suffix}
                      id="dropdown-menu-suffix-align-right"
                      onSelect={(e) => {
                        this.setState({
                          suffix:e === '' ? t("pages.profile.pleaseSelect") : e
                        });
                      }}
                    >
                      <Dropdown.Item eventKey="">{t("pages.profile.pleaseSelect")}</Dropdown.Item>
                      <Dropdown.Item eventKey="Jr.">Jr.</Dropdown.Item>
                      <Dropdown.Item eventKey="Sr.">Sr.</Dropdown.Item>
                      <Dropdown.Item eventKey="I">I</Dropdown.Item>
                      <Dropdown.Item eventKey="II">II</Dropdown.Item>
                      <Dropdown.Item eventKey="III">III</Dropdown.Item>
                    </DropdownButton>
                  </div>
                  <div className="popup__wrapper-footer">
                  
                    <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      onClick={(e) => this.onNext(e)}
                    >
                      {t(buttonName)}
                    </Button>
                    {
                      (this.props.isLogoutLinkPresent) &&
                      <p
                        role="button"
                        tabIndex={0}
                        className="blue-link"
                        onClick={() => onClose()}
                        onKeyPress={() => onClose()}
                        aria-label={t("pages.profile.cancel")}
                      >{t("pages.profile.cancel")}</p>
                    }
                  </div>
                </Form>
              </div>
            </Container>
          </div>
        </FocusTrap>
      </Modal>
    );
  }
}

ChangeEditNamePopup.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  givenName: PropTypes.string,
  sn: PropTypes.string,
  middleName: PropTypes.string,
  title: PropTypes.string,
  suffix: PropTypes.string,
  onChangeEditNameHandler: PropTypes.func.isRequired,
};

ChangeEditNamePopup.defaultProps = {
  givenName: "",
  sn:"",
  middleName:"",
  title:"",
  suffix:""
};
export default withTranslation()(ChangeEditNamePopup);